<template>
  <div class="price-Review">
    <div class="nav">
      <el-form :model="form" label-width="85px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="业务名称:">
          <el-input v-model="form.businessName" size="mini" placeholder="请输入业务名称"></el-input>
        </el-form-item>
        <el-form-item label="评审类型:">
          <el-select v-model="form.reviewType" filterable size="mini" placeholder="请选择评审类型">
            <el-option v-for="(item,index) in reviewTypeList" :label="item.classaName" :value="item.id" :key="`${index}qw`"></el-option>
          </el-select>
       </el-form-item>
       <!-- <el-form-item label="合同编号:">
         <el-input v-model="form.number" size="mini" placeholder="请输入合同编号"></el-input>
       </el-form-item>
       <el-form-item label="客户合同编号:" label-width="100px">
         <el-input v-model="form.customerNumber" size="mini" placeholder="请输入客户合同编号"></el-input>
       </el-form-item>
       <el-form-item label="签订公司:">
         <el-input v-model="form.company" size="mini" placeholder="请输入合同签订公司"></el-input>
        </el-form-item> -->
        <el-form-item label="创建时间:">
          <el-date-picker v-model="form.startDate" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期"/>
          <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
          <el-date-picker v-model="form.endDate" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期"/>
        </el-form-item>
        <!-- <el-form-item label="开始日期:">
          <el-date-picker v-model="form.startDate" type="date" size="mini" placeholder="请选择开始日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item label="结束日期:">
          <el-date-picker v-model="form.endDate" type="date" size="mini" placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item> -->
        <el-form-item label="审核状态:">
          <el-select v-model="form.state" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="未通过" value="3"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="exportButton"><span @click="exportData" style="cursor:pointer;font-size: 16px;">导出数据</span></div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="businessName" label="业务名称" align="center"/>
          <el-table-column prop="reviewTypeShow" label="评审类型" align="center">
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间" align="center">
            <template slot-scope="scope">
              {{scope.row.createTime |formatTime}}
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.state ==1">待审核</div>
              <div v-if="scope.row.state ==2">已通过</div>
              <div v-if="scope.row.state ==3">未通过</div>
              <div v-if="scope.row.state ==4">已取消</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button size="mini" class="yellow-bg" @click="modifyClick(scope.row)" v-if="scope.row.state !=4 && scope.row.state !=2" >修改</el-button>
                <el-button  size="mini" type="danger" @click="rejectClick(scope.row)"
                            v-if="scope.row.state !=4 && scope.row.state !=3 && scope.row.state !=2" >取消申请</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="addflag"  width='700px' center @close="dialogClose">
      <div class="add">
        <div class="baseInfo">

          <div class="baseInfoContent">

            <el-form :model="modifyData" label-width="150px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <div-border label="基础信息" prop="plan">
                <div class="yang">
                  <el-form-item label="业务名称:"  prop="businessName" style="margin-top: 15px">
                    <el-input v-model="modifyData.businessName" size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="评审类型:" prop="reviewType">
<!--                    <el-radio-group v-model="modifyData.reviewType">-->
<!--                      <el-radio v-for="(item,index) in reviewTypeList" :label="item.id" :key="`${index}re`">{{item.classaName}}</el-radio>-->

<!--                    </el-radio-group>-->
                    <el-radio v-model="modifyData.reviewType" v-for="(item,index) in reviewTypeList" :label="item.id" :key="item.id">{{item.classaName}}</el-radio>
                  </el-form-item>
                  <el-form-item label="评审需求:" prop="reviewDemand">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 6}"
                      placeholder="请输入内容"
                      v-model="modifyData.reviewDemand" size="mini">
                    </el-input>
                  </el-form-item>


                </div>


              </div-border>
              <div-border label="上传附件" >
                <el-form-item style="margin-top:15px;">
                  <div class="imgUp">
                    <el-upload
                      ref="upload"
                      class="upload-demo"
                      :action="uploadUrl"
                      :auto-upload="true"
                      :before-upload="beforeAvatarUpload"
                      :show-file-list="false"
                      :data="uploadData"
                      :on-change="uploadChange"
                      :on-success="(res) => uploadImgFun(res, 2)"
                      :file-list="modifyData.img"
                      :limit="5"
                    >
                      <!--                    <i class="el-icon-plus"/>-->
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-top: 6px;margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
                    </el-upload>
                    <div v-for="(item,index) in modifyData.img">
                      <div class="upload">
                        <div style="white-space:nowrap; text-overflow:ellipsis;overflow:hidden;width: 360px">{{item.name}}</div>
                        <div>
                          <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item,index)"
                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                              ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                          <i class="el-icon-upload2" @click="uploadClick(item,index)"></i>
                          <i class="el-icon-delete" @click="handleRemove(item,index)"></i></div>
                      </div>
                    </div>

                  </div>
                </el-form-item>
              </div-border>

            </el-form>
            <div class="btnContainer">
              <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">{{dilogNumber===1 ? "添加" :"修改"}}</el-button>
              <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
            </div>
          </div>

        </div>

      </div>

    </el-dialog>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='673px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.stateShow}}</p>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData"  label-position="left">
              <el-form-item label="业务名称:">
                <span>{{detailData.businessName}}</span>
              </el-form-item>
              <el-form-item label="评审类型:">
                <span>{{detailData.reviewTypeShow}}</span>
              </el-form-item>
              <el-form-item label="评审需求:">
                <span>{{detailData.reviewDemand}}</span>
              </el-form-item>

            </el-form>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>附件信息</span>
            </div>
            <div class="baseInfoContent">
              <div style="display: flex">
                <el-form :model="detailData" label-position="left" style="width: 100%">
                  <!-- <el-form-item label="查看附件人">
                    {{}}
                  </el-form-item> -->
                  <el-row :gutter="30" style="width: 100%" v-for="(item,index) in detailData.img" :key="`${index}b`">
                    <el-col :span="12" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{item.name}}
                    </el-col>
                    <el-col :span="7">
                      {{item.uploadTime}}</el-col>
                    <el-col :span="3">
                        <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item,index)"
                           v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                            ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                    </el-col>
                    <el-col :span="2">
                    <i class="el-icon-download" @click="downloadClick(item.id)"></i>
                     </el-col>

                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>审核信息</span>
            </div>
            <div class="operationTable">
              <steps :step-data="stepData" :step-state="stepState"/>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" append-to-body >
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";
  import { getSessionStore} from "@/config/mUtils"
  import uploadImg from "@/components/uploadImg";
  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  import {
    formatTime
  } from "@/config/mUtils";
  import {
    priceReviewPageList,
    priceReviewUpdate,
    priceReviewAdd,
    priceReviewDetail,
    priceReviewCancelApplyFor,
  } from "@/service/contract";
  import {
    selectListBySourceId,
  } from "@/service/getData";
  import {busiPriceReviewType} from "@/service/audit"
  export default {
    components: {
      uploadImg,
      divBorder,
      steps
    },

    data() {
      return {
        form:{
          time: ['', ''],
          status: '',
          businessName:"",
          reviewType:"",
          startDate:"",
          endDate:'',
          state:"",
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        TableDatas:[],
        detailDialogVisible:false,
        detailData:{},
        modifyData:{
          businessName:'',
          reviewType:'',
          reviewDemand:'',//审核需求
          attachmentIdStr:'',//附件地址id拼接字段
          img:[],},
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        baseImgUrl: baseImgUrl + "/",
        uploadUrl: "",
        dialogTitle:'',
        uploadData: {
          fileType: "0",
        },
        uploadFlag:false,//替换
        uploadIndex:'',//替换索引
        dialogVisible:false,
        addflag:false,
        addLoad:false,
        // 1 为添加 2 修改
        dilogNumber : 1,
        dialogImageUrl:'',
        //存储成功回调附件地址
        dialogImageUrlList:[],
        startCastingTimeOptions:{
          disabledDate(time) {
            return time.getTime() < Date.now() - 86400000;
          }
        },
        reviewTypeList:[],
        reviewTypeMap:new Map(),
        rules:{
          plan:{required: true, message: ' ', trigger: 'blur'},
          businessName:[
            { required: true, message: '请输入业务名称', trigger: 'blur' },
            // { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          reviewDemand:{required: true, message: '请输入评审需求', trigger: 'blur'},
          reviewType: { required: true, message: '请选择评审类型', trigger: 'blur' },
          img:{ required: true, message: '请选择合同照片', trigger: 'blur' },

        }

      };

    },
    filters:{
      formatTime(val){
        return formatTime(val,"yyyy-mm-dd hh:ii:ss")

      }
    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
    },
    created() {
      this.$nextTick(()=>{
        this.init()
      })
    },
    methods: {
      //导出数据
      exportData(){
        let {
          time,
          status,
          businessName,
          reviewType
        } = this.form
        console.log(this.form);
        // let token = getSessionStore('token')
        // window.location.href = `${baseUrl}/platform/busi/priceReview/export?access_token=${token}&state=${status}&startDate=${time[0]===undefined?'':time[0]}&endDate=${time[1]===undefined?'':time[1]}&businessName=${businessName}&reviewType=${reviewType}`
        window.exportExcelGet('/platform/busi/priceReview/export', `state=${status}&startDate=${time[0]===undefined?'':time[0]}&endDate=${time[1]===undefined?'':time[1]}&businessName=${businessName}&reviewType=${reviewType}`)
      },
      init(){
        this.uploadUrl = baseUrl + "/web/attachmentFtp/upload";
        this._priceReviewPageList()
        this._busiPriceReviewType()
      },
      async _priceReviewPageList(){
        this.tableLoad = true;
        let res = await  priceReviewPageList(this.form)
        this.tableLoad = false
        if (res.status !==0){
          return  this.$message.error(res.message)
        }
        this.TableDatas = res.data.records
        this.total = res.data.total
      },
      async _busiPriceReviewType(){
        let res =await busiPriceReviewType({categoryCd:'contract_price'})
        if (res.status !==0)   return  this.$message.error(res.message)
        this.reviewTypeList = res.data
        this.reviewTypeList.forEach((item,index)=>{
          this.reviewTypeMap.set(item.id,item.classaName)
        })


      },
      async _selectListBySourceId(id){
        let res =await selectListBySourceId(id)
        if (res.status !==0) return  this.$message.error(res.message)
        //拼接 附件数组
        let array = res.data.map(item=>{
          return {
            name:item.attachmentName,
            url:this.baseImgUrl + item.attachmentGroup+ "/" + item.attachmentPath,
            status:'success',
            id:item.id,
            uploadTime:item.uploadTime
          }
        })
        return array;
      },

      addBtn(){
        // 1 为添加 2 修改
        this.dilogNumber = 1
        this.dialogTitle = "新增价格审批"
        this.addflag = true
      },
      searchBtn(){
        this.form.page = 1;
        this._priceReviewPageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
        this._priceReviewPageList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._priceReviewPageList()
      },
      // 详情
     async detailClick(row){
        this.detailDialogVisible = true
        let  res =await priceReviewDetail({id:row.id})
       if (res.status !==0){
         return  this.$message.error(res.message)
       }
       this.detailData = res.data
       let array =await this._selectListBySourceId(row.id)
       this.$set(this.detailData,'img',array)


      },
      //详情附件下载
      downloadClick(id){
        let token = getSessionStore('token')
        window.location.href = baseUrl + "/web/attachmentFtp/download?attachmentId="+ id +"&access_token="+
          token
      },
      async modifyClick(row){
        // 1 为添加 2 修改
        this.dilogNumber = 2
        this.dialogTitle = "修改价格审批"
        this.addflag = true
        this.modifyData={
          ...row,
          img:[]
        }
        let array =await this._selectListBySourceId(row.id)
        //将拼接id字段转类型
        this.modifyData.attachmentIdStr='';
        this.$set(this.modifyData,'img',array)

      },
      rejectClick(row){
        this.$confirm('确认要取消价格审批吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res =await priceReviewCancelApplyFor({id:row.id})
          if (res.status !==0) return  this.$message.error(res.message)
          this.$message.success(res.message)
          this._priceReviewPageList()
        }).catch(() => {});
      },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 1024 / 1024 < 10
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB')
        this.addLoad = true;
        // return isJPG && isLt10M
        return isLt10M
      },
      uploadChange(file, fileList){
          if (this.uploadFlag) {
            this.modifyData.img.splice(this.uploadIndex, 1, file)
          } else {
            this.modifyData.img = fileList;
            console.log(fileList)
          }
        if (Object.keys(file).includes('response')){
          if (file.response.status ==-1){
            this.modifyData.img.splice(this.modifyData.img.indexOf(file),1)
          }
        }

      },
      handleRemove(item,index) {
        this.modifyData.img.splice(index,1)
      },
      handlePictureCardPreview(item,index){
        let token = getSessionStore('token');
        this.dialogImageUrl = baseUrl + "/web/attachmentFtp/download?attachmentId="+(item.id||item.response.data.id)+"&access_token="+token;
        this.dialogVisible = true;
      },
      //外部上传方法，替换
      uploadClick(item,index){
        this.uploadIndex= index
        this.uploadFlag = true
        this.$refs.upload.$refs['upload-inner'].handleClick()

      },
      //附件上传成功回调
      uploadImgFun(res, val) {
        this.addLoad = false;
        if (res.status == 0) {
              this.$message.success(res.message);
          if (this.uploadFlag){//如果为替换，得到索引值进行替换
            this.dialogImageUrlList.splice(this.uploadIndex,1,{'id':res.data.id})
            console.log( this.dialogImageUrlList)
            this.uploadFlag =false;
          }else {
            this.dialogImageUrlList.push({'id':res.data.id})
            console.log( this.dialogImageUrlList)
          }

        } else {
          this.$message.error(res.message);
          this.uploadFlag =false;

        }
      },
      closeDialog(){
        this.dialogVisible = false
      },
      addClick(){
        this.$refs.ruleForm.validate(async(valid,val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            // 1 为添加 2 修改
            if (this.dilogNumber===1){
              console.log("添加")
              this.modifyData.attachmentIdStr ='';
              let tempList = [];
              if(this.modifyData.img.length > 0) {
                this.modifyData.img.forEach(item => {
                  if(item.status=='success' && item.response) {
                    tempList.push(item.response.data.id);
                  }
                })
              }
              this.modifyData.attachmentIdStr = tempList.join(',');
              this.addLoad = true;
              // this.dialogImageUrlList.forEach((item,index)=>{
              //   if (this.dialogImageUrlList.length-1 ===index){
              //     this.modifyData.attachmentIdStr += item.id
              //   }else {
              //     this.modifyData.attachmentIdStr += item.id+','
              //   }
              // })
              let res =await priceReviewAdd(this.modifyData)
              if (res.status !=0){
                this.addLoad = false;
                return  this.$message.error(res.message)
              }
              this.$message.success(res.message)
            }else {
              let modifyData = {
                ...this.modifyData
              }
              modifyData.img.forEach((item,index)=>{
                if (modifyData.img.length-1 ===index){
                  item.response ? modifyData.attachmentIdStr += item.response.data.id : modifyData.attachmentIdStr+=item.id
                }else {
                  item.response ? modifyData.attachmentIdStr += item.response.data.id+"," : modifyData.attachmentIdStr +=item.id+","
                }
              })
              this.addLoad = true;
              let updateRes =await priceReviewUpdate(modifyData);
              this.addLoad = false;
              if (updateRes.status !==0) return this.$message.error(updateRes.message)
              this.$message.success(updateRes.message)
              console.log("修改")
            }
            this.dialogClose()

            // for (const argumentsKey in this.modifyData) {
            //   if (argumentsKey == "img"){
            //     this.modifyData[argumentsKey] = []
            //   }else {
            //     this.modifyData[argumentsKey] = ''
            //   }
            //
            // }
            this._priceReviewPageList()


          } else {
            return false;
          }
        });
      },
      dialogClose(){
        this.modifyData={
          businessName:'',
          reviewType:'',
          reviewDemand:'',//审核需求
          attachmentIdStr:'',//附件地址id拼接字段
          img:[],
        }
        this.$refs.ruleForm.resetFields();
        this.modifyData.img=[]
        this.addflag = false

      },
      // 结束时间
      dateChange(val) {
        if(this.form.endDate&&this.form.startDate&&(this.form.endDate <= this.form.startDate)) {
          if(val == this.form.endDate) this.form.endDate = '';
          if(val == this.form.startDate) this.form.startDate = '';
          return this.$message.warning("结束日期必须大于开始日期！");
        }
      },

    },
  };
</script>



<style lang="scss" scoped>
  .price-Review{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .exportButton{
      text-align: end;
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      .tableContainer{
        margin-bottom: 25px;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
          .el-table th>.cell{
            font-weight: 700!important;
          }
        }
      }
    }
    ::v-deep .detail{
      .el-form-item__label{
        font-weight: 700;
      }

      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .el-form-item{
            margin-bottom: 2px;
            .el-form-item__label{
              /*color: #060606;*/
            }
          }


        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
    ::v-deep .add{

      .el-form-item__label{
        font-weight: 700;
      }
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;

      .baseInfo{
        display: flex;
        flex-direction: column;

        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .yang{
            .el-form-item{
              /*.el-form-item__error{*/
              /*  left: 40px;*/
              /*}*/
              margin-bottom:15px;

              /*.el-form-item__label{*/
              /*  width: 150px !important;*/
              /*  !*color: #060606;*!*/
              /*}*/
              .el-input{
                width: 430px;
              }
              .el-textarea{
                width: 250px;

              }
            }

          }
          .el-upload-list__item{
            width: 100px;
            height: 100px;
          }
          .el-upload--picture-card{
            width: 100px;
            height: 100px;
            line-height: 100px;
          }
          .imgUp{
            /*display: flex;*/
            /*flex-direction: column;*/
            /*.imgLength{*/
            /*  display: flex;*/
            /*  align-items: center;*/
            /*  width:100%;*/
            /*  span{*/
            /*    margin-left:auto;*/
            /*    color: rgb(183, 183, 183);*/
            /*    font-size: 16px;*/
            /*  }*/
            /*}*/
            .upload-demo{
              display: flex;
            }
            .upload{
              font-size: 17px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              i{
                margin-right: 10px;
              }
              i:hover{
                color: #00e1ff;
              }
            }
          }
        }
      }

      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }
::v-deep {
  .el-form--inline .el-form-item {
    margin-bottom: 5px;
  }
}

</style>
